module.exports = __webpack_public_path__ + "static/media/fornecedor.43fe18c6.jpg";